module.exports = __webpack_public_path__ + "fee4d0281e994434df8e22d507d2f585.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/festival.jpg
// module id = 626
// module chunks = 0